import { render } from "./LoginAndGuestCheckoutCard.vue?vue&type=template&id=188983c4"
import script from "./LoginAndGuestCheckoutCard.vue?vue&type=script&lang=js"
export * from "./LoginAndGuestCheckoutCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QBtn});
